<template>
<div class="hero-body" :class="[finder]">
  <div class="container">
    <div class="columns chartcontainer is-gapless">
      <div class="column is-4">
        <h1>{{this.client}}</h1>
        <h2>Search Engine Optimization Results</h2>
        <div class="moreinfo"><slot></slot></div>
      </div>
      <div class="column is-8">
        <div class="chart" :class="[{ 'inview' : inview }]">
          <v-waypoint @waypoint-in="addInview" @waypoint-out="removeInview" class="chart--waypoint"></v-waypoint>
          <ul>
            <li v-for="(chartdataset,index) in chartdata" :key="index" :style="{ width: getWidth() }">
              <div @mouseover="barOver" @mouseleave="barOff" :style="{ height: getPct(chartdataset) }" :class="getColor(index)" :title="formatMonth(index, chartdataset)" v-bind:key="index">
              </div>
            </li>
          </ul>
          <div class="legend columns">
            <div class="column" v-if="this.initialmonth > -1">
              <div class="before"></div>
              <b>Before Visible SEO Campaign</b>
            </div>
            <div class="column">
              <div class="after"></div>
              <b>During Visible SEO Campaign</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'bmv-bar-chart',
  props: ['client', 'chartdata', 'initialmonth', 'monthlabel', 'finder','left'],
  data: () => {
    return {
      inview: false
    }
  },
  methods: {
    addInview: function () {
      // this.inview = true
      this.showInview()
      // var bmvc = document.querySelector('.bmv-reflection .' + this.finder + ' .chart')
      // bmvc.classList.add('inview')
    },
    removeInview: function () {
      // this.inview = false
      this.hideInview()
      // var bmvc = document.querySelector('.bmv-reflection .' + this.finder + ' .chart')
      // bmvc.classList.remove('inview')
    },
    showInview: function () {
      // var elements = this.$el.querySelectorAll('.chart li div')
      // var elements2 = document.querySelectorAll('.bmv-reflection .' + this.finder + ' .chart li div')
      // Array.prototype.forEach.call(elements2, function (el, i) {
      //   setTimeout(function () { el.classList.add('inview') }, 50 * i)
      // })
      // Array.prototype.forEach.call(elements, function (el, i) {
      //   setTimeout(function () { el.classList.add('inview') }, 50 * i)
      // })
      // this.$el.document.querySelector('.chart').classList.add('inview')
      this.inview = true
      const reflectedChart = document.querySelector('.bmv-reflection .'+ this.finder + ' .chart')
      if (reflectedChart) {
        reflectedChart.classList.add('inview')
      }
    },
    hideInview: function () {
      this.inview = false
      const reflectedChart = document.querySelector('.bmv-reflection .'+ this.finder + ' .chart')
      if (reflectedChart) {
        reflectedChart.classList.remove('inview')
      }
      // var elements = this.$el.querySelectorAll('.chart li div')
      // var elements2 = document.querySelectorAll('.bmv-reflection .' + this.finder + ' .chart li div')
      // Array.prototype.forEach.call(elements2, function (el, i) {
      //   setTimeout(function () { el.classList.remove('inview') }, 50 * i)
      // })
      // Array.prototype.forEach.call(elements, function (el, i) {
      //   setTimeout(function () { el.classList.remove('inview') }, 50 * i)
      // })
      // this.$el.document.querySelector('.chart').classList.remove('inview')
    },
    barOver: function (event) {
      event.target.classList.add('hover')
      let bars = document.querySelectorAll('.chart ul li div')
      let n = Array.prototype.indexOf.call(bars, event.target)
      bars[(bars.length / 2) + n].classList.add('hover')
    },
    barOff: function (event) {
      event.target.classList.remove('hover')
      let bars = document.querySelectorAll('.chart ul li div')
      let n = Array.prototype.indexOf.call(bars, event.target)
      bars[(bars.length / 2) + n].classList.remove('hover')
    },
    getPct: function (value) {
      return (value / (Math.max.apply(Math, this.chartdata) / 100)) + '%'
    },
    getWidth: function () {
      return 100 / this.chartdata.length + '%'
    },
    getColor: function (value) {
      if (value <= this.initialmonth) {
        return 'before'
      } else {
        return 'after'
      }
    },
    formatMonth: function (value, pct) {
      if (value <= this.initialmonth) {
        return 'Before Visible SEO Campaign'
      } else {
        return this.monthlabel + ' ' + (value - this.initialmonth) + ': Up ' + Math.round(pct - 100) + '%'
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@media (min-width:450px) {
.chartcontainer {
  display:flex;
}
}
@media (max-width:450px) {
  .moreinfo {
    display:none;
  }
  h2 {
    font-size:10px;
  }
  .legend {
    margin-top:15px;
  }
}
.moreinfo {
  color:#666;
  background-color:#fff;
  box-shadow:8px 8px 0px rgba(0,0,0,0.1);
  margin:20px 0px;
  padding:10px;
  font-size:12pt;
  line-height:20pt;
  p {
    line-height:16pt;
    padding:10px;
  }
}
.chart--waypoint {
  position:absolute;
  top:50vh;
}
.chart.inview ul li div {
  transform:scale3d(1,1,1);
}
@for $i from 1 to 21 {
  .chart ul li:nth-child(#{$i}) div {
    transition-delay: #{$i * 50}ms;
  }
}
.chart {
  // height:100vh;
  // max-width:800px;
  position:relative;
  width:100%;
   padding:20px;
  
}
.right {
  h1, h2 {
    text-align:center;
  }
}
h1 {
  font-size:30pt;
  text-shadow: 3px 3px rgba(black, 0.2);
  color:#fff;
  font-weight:bold;
  text-align:center;
}
h2 {
 font-size:14pt;
  text-shadow: 2px 2px rgba(black, 0.2);
  color:#fff;
  text-align:center;
}
ul {
  display:flex;
  align-items:center;
  justify-content:center;
  li {
    display:flex;
    flex-direction:column-reverse;
    position:relative;
    text-align:center;
    height:400px;
    @media (max-height: 750px) {
      height:250px;
    }
    z-index:1;
    div {
      width:90%;
      box-shadow: 10px 15px rgba(black, 0.2);
      transform: scale3d(1,0.1,1);
      transform-origin:bottom center;
      transition:transform 0.5s ease-in-out;
      opacity:0.8;
    }
    div.hover {
      opacity:1;
    }
    div.hover::after {
      content: attr(title);
      padding:10px;
      position:absolute;
      right:0px;
      top:20px;
      text-align:center;
      width:180px;
      border:5px solid #fff;
      border-radius:25px;
      font-weight:bold;
      color:#fff;
      background:#666;
      box-shadow: 10px 15px rgba(black, 0.2);
      z-index:10;
    }
  }
}
.legend {
  .before, .after {
    width:40px;
    height:20px;
    float:left;
    margin-right:20px;
    box-shadow: 10px 15px rgba(black, 0.2);
  }
  margin-top:50px;
  b {
    color:#666;
    @media (max-width:400px) {
      font-size:10px;
    }
  }
}

.before {
  background-image: linear-gradient(
    to right top,
    transparent 33%,
    white 33%,
    white 66%,
    transparent 66%
  );
  background-size: 3px 3px;
}
.after {
  background-color:#fff;
}

</style>



// WEBPACK FOOTER //
// Chart.vue?0db10b92